import { SET_LOADING } from "../../actionTypes"

export const setLoadingGeral = (loading, mensagem = '') => {
    return {
        type: SET_LOADING,
        payload: { loading, mensagem }
    }
}
